import {
  ScheduleSettingsSlot,
  Slot,
  Status,
} from "@shared/features/agenda/types/agenda-settings.types";
import { api } from "./common/base";
import { PatientListService } from "./common/patient-list";

export class DoctorService extends PatientListService<any> {
  constructor() {
    super("doctor");
  }

  public updateScheduleSettings({
    settings,
    id,
  }: {
    settings: {
      slots: Array<{
        start: string;
        end: string;
      }>;
      duration: number;
    };
    id?: string;
  }) {
    return api
      .post("/user-schedule/doctor/settings", settings, { params: { id } })
      .then((res) => res.data);
  }

  public getSchedule({ id }) {
    return api.get(`/user-schedule/doctor/${id}`).then((res) => res.data);
  }

  public requestScheduleAccess({ id }) {
    return api
      .get(`/user-schedule/doctor/${id}/request-access`)
      .then((res) => res.data);
  }

  public getStatistics({ doctorId }) {
    return api.get(`/doctor/${doctorId}/statistics`).then((res) => res.data);
  }

  public createScheduleSlots({
    slots,
    id,
  }: {
    slots: Array<{
      start: string;
      end: string;
      status: Status;
    }>;
    id?: string;
  }) {
    return this.api
      .post(`../user-schedule/doctor/slots`, slots, { params: { id } })
      .then((res) => res.data);
  }

  public deleteScheduleSlots({
    slotIds,
    id,
  }: {
    slotIds: string[];
    id?: string;
  }) {
    return this.api
      .delete(`../user-schedule/doctor/slots`, {
        params: { id },
        data: { slotIds },
      })
      .then((res) => res.data);
  }
}
